module.exports = __webpack_public_path__ + "static/media/zyxgh5.804b5ac5.png";